import { object, string } from "yup";
import { FormValues } from "../../../../../duck";

export const getValidation = (defaultValues: FormValues, inputName: string) => {
  const validationSchema = object({
    [inputName]: string()
      .required("Token can’t be blank.")
      .default("")
  });

  return {
    validationSchema,
    defaultValues: validationSchema.cast(defaultValues)
  };
};
